import React, { useState } from 'react'
import {
  useDataGrid,
  EditButton,
  ShowButton,
  DeleteButton,
  List,
} from '@refinedev/mui'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import { Box, Button } from '@mui/material'
import MergeRegionsModal from '../../components/MergeRegions'
import ManageRegionSetsModal from '@/components/ManageRegionSetsModal'
import { locationDeleteErrorNotification } from '@/utils/adminFacingError'

export const RegionsList = () => {
  const [showMergeRegions, setShowMergeRegions] = useState(false)
  const [showManageRegionSets, setShowManageRegionSets] = useState(false)
  const { dataGridProps } = useDataGrid({
    resource: 'regions',
    errorNotification: (error) => {
      return {
        message: 'Error getting locations',
        description:
          error?.message || 'An error occurred while fetching locations',
        type: 'error',
      }
    },
  })

  const columns = React.useMemo<GridColDef[]>(
    () => [
      {
        field: 'id',
        headerName: 'Id',
        type: 'number',
        minWidth: 50,
      },
      {
        field: 'name',
        flex: 1,
        headerName: 'Name',
        minWidth: 200,
      },
      {
        field: 'country',
        flex: 1,
        headerName: 'Country',
        minWidth: 150,
      },
      {
        field: 'region',
        flex: 1,
        headerName: 'Region',
        minWidth: 150,
      },
      {
        field: 'council',
        flex: 1,
        headerName: 'Council',
        minWidth: 150,
      },
      {
        field: 'major',
        flex: 1,
        headerName: 'Major (City, Town)',
        minWidth: 150,
      },
      {
        field: 'suburb',
        flex: 1,
        headerName: 'Suburb',
        minWidth: 200,
      },
      {
        field: 'additional_names',
        flex: 1,
        sortable: false,
        headerName: 'Additional Names',
        minWidth: 50,
        renderCell: function render({ value }) {
          return (
            <div style={{ overflow: 'auto', maxHeight: '100px' }}>
              {value.join(', ')}
            </div>
          )
        },
      },
      {
        field: 'actions',
        headerName: 'Actions',
        sortable: false,
        renderCell: function render({ row }) {
          return (
            <>
              <ShowButton hideText recordItemId={row.id} />
              <EditButton hideText recordItemId={row.id} />
              {!row.is_public_base && (
                <DeleteButton
                  hideText
                  recordItemId={row.id}
                  errorNotification={locationDeleteErrorNotification}
                />
              )}
            </>
          )
        },
        align: 'center',
        headerAlign: 'center',
        minWidth: 80,
      },
    ],
    [],
  )

  return (
    <>
      {showMergeRegions && (
        <MergeRegionsModal
          open={showMergeRegions}
          onClose={() => setShowMergeRegions(false)}
        />
      )}
      {showManageRegionSets && (
        <ManageRegionSetsModal
          open={showManageRegionSets}
          onClose={() => setShowManageRegionSets(false)}
        />
      )}
      <List>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            mt: -2,
            mb: 1,
            gap: 2,
          }}
        >
          <Button
            variant="contained"
            onClick={() => setShowManageRegionSets(true)}
          >
            {' '}
            Manage Location Sets
          </Button>
          <Button variant="contained" onClick={() => setShowMergeRegions(true)}>
            {' '}
            Merge Locations
          </Button>
        </Box>
        <DataGrid {...dataGridProps} columns={columns} autoHeight />
      </List>
    </>
  )
}
